"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MOD_COM_ACTUAL_FACING = void 0;
var client_1 = require("@apollo/client");
exports.MOD_COM_ACTUAL_FACING = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  fragment ModComActualFacing on Actual {\n    upc\n    index\n    vFacingUpcs\n    distanceFromHome\n  }\n"], ["\n  fragment ModComActualFacing on Actual {\n    upc\n    index\n    vFacingUpcs\n    distanceFromHome\n  }\n"])));
var templateObject_1;
